module.exports = __webpack_public_path__ + "src/client/assets/img/taxfyle-logo.png";